import React from 'react';

export default [
  {
    isFeatured: true,
    title: 'History',
    id: 'history',
    subtitle: 'Available Now',
    releaseDate: '2023-06-03',
    image: 'https://bokante.com/assets/albums/history.jpg',
    links: [
      {
        text: 'Listen and Buy Now',
        url: 'https://lnk.to/RW244'
      }
    ],
    content: (
      <div>
        <p>On their third album, Bokanté have plugged into the blues, tracing the genre’s roots in West Africa and the Arab world through the diaspora into the retro-modern present. These nine tracks tell — with lyrics sung mainly in Guadeloupean Creole — of outsiders and seers, memories and joy; of black history, global unity and the futility of war. Of taking time to rest, feel, love. Of the redemptive power of music — as a conduit, a change maker, a muse.</p>
        <p>
        History finds Bokanté exploring further, dressing folkloric instruments including the Arabic oud, West African ngoni and North African guembri, the bass lute favoured by Morocco’s Gnawa maalems, in western clothes. Interweaving layers of percussion with all the nuanced skill expected of four percussion maestros: André Ferrari of Swedish folk renegades Väsen. Ex-Berklee music professor Jamey Haddad (Sting, Paul Simon). Nagasaki-raised, New York-based Keita Ogawa (Cecile McLorin Salvant). Ghanaian-New Orleanian drum king Weedie Braimah (Christian Scott), a special guest on What Heat, a vital band member now.
        </p>
        <p>Band members including Snarky Puppy guitarists Chris McQueen and Bob Lanzetti and South Florida raised-lap steel player Roosevelt Collier had previously recorded remotely, absorbing and embellishing the music sent to them in files by co-writers Tirolien and League, who was often elsewhere with other projects. While History’s painterly lyrics were primarily written by the Guadalupe-born Tirolien during lockdown in Montreal, the re-opening of the world saw the entire ensemble converge on League’s home in a tiny village outside Barcelona, Spain. </p>
      </div>
    ),
    tracks: [
      { title: 'Bliss' },
      { title: 'Adjoni' },
      { title: 'Pa Domi' },
      { title: 'Illiminé' },
      { title: 'Flè a Mémwa' },
      { title: 'Ta Voix' },
      { title: 'Tandé' },
      { title: 'Mikrob' },
      { title: 'History' },
    ],
    credits: [
      { name: 'Malika Tirolien', part: 'vocals' },
      { name: 'Weedie Braimah', part: 'djembe, congas' },
      { name: 'Keita Ogawa', part: 'congas, dohola, cymbal, chains, claps, bendir, bells, darbuka, surdo, caixa, riq, krakeb, kanjira, timbau, bomb legüero' },
      { name: 'Jamey Haddad Kuwaiti', part: 'tar, ocean drum, finger cymbal, chains, bells, claps, kanjira, cowbell, shekere, palm brushes, vocal percussion, bendir, darbuka, metal pots, anklung' },
      { name: 'André Ferrari', part: 'bombo legüero, frame drum, bells, grouse pipe, bass drum' },
      { name: 'Michael League', part: 'guimbre, electric oud, electric bass, vocals, claps, ngoni, krakeb' },
      { name: 'Chris McQueen', part: 'electric and acoustic guitars' },
      { name: 'Bob Lanzetti', part: 'electric and acoustic guitars, nylon string guitar' },
      { name: 'Roosevelt Collier', part: 'lap steel guitar' },
    ]
  },
  {
    isFeatured: true,
    title: 'Exit 16',
    id: 'exit16',
    subtitle: 'Available Everywhere',
    releaseDate: '2018-03-09',
    image: '/assets/exit-16.jpg',
    links: [
      {
        text: 'Listen on Spotify',
        url: 'https://open.spotify.com/album/02n4Aj3cImlUQe70gdTX43?si=OPlEWL9dTd61VposlFrc6A'
      },
      {
        text: 'Buy MP3',
        url: 'https://store.groundupmusic.net/collections/roosevelt-collier/products/exit-16-mp3-download'
      },
      {
        text: 'Buy Vinyl',
        url: 'https://store.groundupmusic.net/collections/roosevelt-collier/products/exit-16-vinyl'
      },
      {
        text: 'Buy FLAC',
        url: 'https://store.groundupmusic.net/collections/roosevelt-collier/products/exit-16-flac-download'
      },
    ],
    content: (
      <div>
        <blockquote>“My mission is to touch and heal people through music [...] That’s always been my mission, whether it’s in the church or in a club. I think people feel better about themselves after I play. That’s powerful, my man! I’ve been blessed to have that going for me. That’s my gift.”</blockquote>
      </div>
    ),
    tracks: [
      { title: 'Sun Up Sun Down', length: '5:27' },
      { title: 'Happy Feet', length: '6:03' },
      { title: 'Make It Alright', length: '6:53' },
      { title: 'Exit 16', length: '6:05' },
      { title: 'That Could\'ve Been Bad', length: '8:06' },
      { title: 'Supernatural Encounters', length: '4:28' },
      { title: 'Spike', length: '8:37' },
    ],
    credits: [
      { name: 'Roosevelt Collier', part: 'Lap Steel Guitar' },
      { name: 'Michael League', part: 'Bass, Producer' },
      { name: 'Bobby Sparks II', part: 'Organ' },
      { name: 'Jason JT Thomas', part: 'Drums' },
      { name: 'Dave "Lil Dave" Chiverton', part: 'Drums' },
      { name: 'Vaughn Henry', part: 'Organ' }
    ]
  },
  {
      title: 'What Heat',
      id: 'bokante-whatheat',
      image: '/assets/albums/what-heat.jpg',
      subtitle: <b>Bokante</b>,
      releaseDate: '2018-09-28',
      content: (
        <div>
          <p>This heat: Bokanté and the Metropole Orkest, together. Two internationally acclaimed outfits made up of players at the top of their games. Music doesn’t get any hotter, or more accomplished, than this.</p>
          <p>A super group of players from five countries and four continents, different genders, races and generations working in harmony, celebrating individuality. A band whose members are united in the belief that music should be a voice for the voiceless, a force for change against a rising tide of exclusion and indifference in a world that is, well, reaching boiling point.</p>
        </div>
      ),
      links: [
        { text: 'Buy Now (all formats)', url: 'http://smarturl.it/RW221' }
      ],
      tracks: [
        { title: 'All the Way Home' },
        { title: 'Fanm' },
        { title: 'Lé An Gadé-w En Zyé' },
        { title: 'Réparasyons' },
        { title: 'Bòd Lanmé Pa Lwe' },
        { title: 'Don’t Do It:' },
        { title: 'Chambre à Échos' },
        { title: 'Maison En Feu ' }
      ],
      credits: [
        { name: 'Malika Tirolien', part: 'vocals' },
        { name: 'Jamey Haddad', part: 'percussion' },
        { name: 'André Ferrari', part: 'percussion' },
        { name: 'Keita Ogawa', part: 'percussion' },
        { name: 'Weedie Braimah', part: 'djembe, vocals' },
        { name: 'Chris McQueen', part: 'guitars, vocals' },
        { name: 'Bob Lanzetti', part: 'guitars, vocals' },
        { name: 'Roosevelt Collier', part: 'steel pedal guitar, vocals' },
        { name: 'Michael League', part: 'guitar, bass, percussion, vocals' },
        { name: 'Jules Buckley', part: 'Conductor' },
        { name: 'Metropole Orkest', part: 'Orchestra' }
      ]
  },
  {
    title: 'Let The Steel Play',
    id: 'letthesteelplay',
    image: '/assets/albums/let-the-steel-play.jpg',
    subtitle: <span>with <b>Andy Hall</b></span>,
    releaseDate: '2017-06-16',
    content: (
      <div>
        <p>Andy Hall of The Infamous Stringdusters and Roosevelt Collier of the Lee Boys have come together on a new album, Let The Steel Play, which is set for independent release June 16, 2017. Let the Steel Play was born out of a love of slide guitar, and a friendship made through music. Andy Hall and Roosevelt Collier met in 2012 on Jam Cruise, and began playing music together when their paths would cross. Both are sought after sit-in players at festivals throughout the country and known for their dexterity, versatility, and intuitive knack for picking up rhythms and melodies.</p>

        <p>Coming from different backgrounds and methods, yet brought together through slide guitar, Roosevelt and Andy have joined forces to create a musical bridge that emanates a freshness, yet honors both traditions.</p>
      </div>
    ),
    links: [
      { text: 'Buy MP3', url: 'https://www.amazon.com/Steel-Play-Andy-Roosevelt-Collier/dp/B072N1CLHF' },
      { text: 'Stream on Amazon Music', url: 'https://music.amazon.com/albums/B072N1CLHF' }
    ],
    tracks: [
      { title: 'This Little Light Of Mine', length: '4:51' },
      { title: 'Maiden’s Prayer', length: '3:48' },
      { title: 'Singing Steel', length: '4:01' },
      { title: 'Crazy Fingers', length: '4:40' },
      { title: 'Rosebud', length: '3:04' },
      { title: 'Reuben’s Train', length: '3:34' },
      { title: 'Remington', length: '3:06' },
      { title: 'The Darkest Hour', length: '4:05' },
      { title: 'Power In the Blood', length: '3:50' },
      { title: 'Colfax Boogie', length: '4:46' }
    ],
    credits: [
      { name: 'Andy Hall', part: 'Tricone, Resonator, Guitar' },
      { name: 'Roosevelt Collier', part: 'Lap Steel Guitar, Resonator' },
      { name: 'Anders Beck', part: 'Resonator' },
      { name: 'John Macy', part: 'Producer' }
    ]
  },
  {
    title: 'Strange Circles',
    id: 'strangecircles',
    subtitle: <b>Bokanté</b>,
    releaseDate: '2017-06-09',
    image: '/assets/strange-circles-small.jpg',
    credits: [
      { name: 'Roosevelt Collier', part: 'Lap Steel Guitar' },
      { name: 'Malika Tirolien', part: 'Vocals' },
      { name: 'Michael League', part: 'Baritone Guitar' },
      { name: 'Bob Lanzetti', part: 'Guitar' },
      { name: 'Chris McQueen', part: 'Guitar' },
      { name: 'André Ferrari', part: 'Percussion' },
      { name: 'Jamey Haddad', part: 'Percussion' },
      { name: 'Keita Ogawa', part: 'Percussion' },
    ],
    content: (
      <div>
        <p>Featuring <b>Roosevelt Collier</b> on Lap Steel guitar, the band’s debut goes from Zeppelin-esque blues stomp to folkloric Caribbean kaladja over the course its ten tracks, blending the extensive and varied knowledge of the individual players with a strong, yet empathetic, lyrical approach. Through it all, Bokanté is a vibrant image of what it wishes to see in the world: connection, unity, and love- through exchange.</p>
      </div>
    ),
    tracks: [
      { title: 'Jou Ké Ouvè' },
      { title: 'Nou Tout Sé Yonn' },
      { title: 'Ola' },
      { title: 'Zyé Ouvè, Zyé Fèmé' },
      { title: 'Roudesann' },
      { title: 'Limyè' },
      { title: 'An Ni Chans ' },
      { title: 'Apathie Mortelle' },
      { title: 'Vayan' },
      { title: 'Héritier' }
    ],
    links: [
      {
        text: 'Buy DVD',
        url: 'https://store.groundupmusic.net/collections/bokante/products/strange-circles-dvd'
      },
      {
        text: 'Buy Vinyl',
        url: 'https://store.groundupmusic.net/collections/bokante/products/strange-circles-vinyl'
      },
      {
        text: 'Buy CD',
        url: 'https://store.groundupmusic.net/collections/bokante/products/strange-circles'
      },
      {
        text: 'Buy MP3',
        url: 'https://store.groundupmusic.net/collections/bokante/products/strange-circles-mp3-download'
      }
    ]
  },
  {
    title: 'The Miami Sessions',
    id: 'themiamisessions',
    subtitle: 'Recorded live on February 7, 2017',
    image: '/assets/miami-sessions-alt.png',
    credits: [
      { name: 'Roosevelt Collier', part: 'Pedal Steel Guitar' },
      { name: 'Michael League', part: 'Bass' },
      { name: 'Dave "Lil Dave" Chiverton', part: 'Drums' },
      { name: 'Vaughn Henry', part: 'Organ' }
    ],
    links: [
        {
          text: 'Free Download (19.6 MB)',
          url: '/downloads/The_Miami_Sessions_[2017].zip'
        }
    ],
    content: (
      <div>
        <p>All tracks recorded live in studio by "DJ Le Spam" Yeomanson at City of Progress Studio in Miami, Florida on February 7<sup>th</sup> 2017 late late at night with a full moon shining through the windows. Mixed by Brendan Monahan at Miner Street Recording, Philadelphia.</p>
      </div>
    ),
    tracks: [
      { title: 'Exit 16', length: '4:15' },
      { title: 'Summer Rose', length: ' 6:22' },
      { title: 'Happy Feet', length: ' 5:16' },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/data/music.jsx